const Box = {

    init() {

        this.el = $('[component="Box"]');

        if (!this.el.length) {
            return;
        }

        this.button = this.el.find('header');

        this.start();
        this.bind();
    },

    start() {
    },

    bind() {
        this.button.click((element) => {
            let content = $(element.currentTarget).parent("section");

            content.toggleClass("hidden");
        });
    },

}
export default Box;